module.exports = __webpack_public_path__ + "static/media/genser.ff562f40.png";